import React, { ComponentState, useEffect, useState } from "react"
import SkeletonTypography from "../../../../../components/SkeletonTypography";
import { Paper, TablePagination } from "@mui/material";
import { DocumentRequestObj, MetaData, ResultDocumentData } from "../../../../../dataModel/documentModels";
import moment from "moment";
import { useDispatch } from "react-redux";
import { getDocumentUrl } from "../../../../../redux/actions";

export interface listProps {
    loadingState: boolean
    documentList: ResultDocumentData[]
    metaObj?: MetaData
    requestObj: DocumentRequestObj
    handleChangePage(event: any, newpage: number): void
    handleChangeRowsPerPage(event: any): void
    tabSelecteionID: string
    tabId: number
}

export const DocumentListComponent = (props: listProps) => {

    const dispatch = useDispatch()
    const {
        loadingState,
        documentList,
        metaObj,
        requestObj,
        tabSelecteionID,
        tabId,
        handleChangePage,
        handleChangeRowsPerPage
    } = props;




    return (
        <div className="tab-pane" id={tabSelecteionID} role="tabpanel">
            {(loadingState) ? <SkeletonTypography /> :
                <Paper>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Doc ID</th>
                                <th>Service Date</th>
                                <th>Document Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody style={{ padding: "auto 10px auto 10px" }}>
                            {
                                documentList?.map((item: ResultDocumentData) => {
                                    return (
                                        <tr >
                                            <td>{item.documentId}</td>
                                            <td>{moment(item.serviceDate).format('MM/DD/YYYY')}</td>
                                            <td>{item.templateName}</td>
                                            <td className="td_link" onClick={() => {
                                                if ((item.clientFillable && item.isClientEditable && tabId === 1)) {
                                                    dispatch(getDocumentUrl({ docId: item.documentId, tabId: tabId, isUpdate: 'updateDoc', isLocked: item?.isLocked, isClientFillable: item.clientFillable }))
                                                } else {
                                                    dispatch(getDocumentUrl({ docId: item.documentId, tabId: tabId, isUpdate: false, isLocked: item?.isLocked, isClientFillable: item.clientFillable }))
                                                }

                                            }}>View Document</td>


                                            {/* {(item.clientFillable && tabId===1) &&
                                                <td className="td_link" onClick={() => {
                                                   
                                                }}>Fill Document</td>} */}

                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100, 500]}
                        component="div"
                        count={metaObj?.totalCount ?? 0}
                        rowsPerPage={requestObj.pageSize}
                        page={requestObj.pageNumber - 1}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            }
        </div>)
}